import {IReg, REG} from "/@lib@/commons/registry.js";
import {IInfo, IInfoBroker, IInfoConsumer} from "/@lib@/commons/infos.js";
import {IDepotUiEnv} from "/@lib@/store/depot.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {BaseElementAsync, OSkinableInit} from "/@back@/commons/basis.js";
import {OLastDatasInit} from "/@lib@/commons/lastDatas.js";
import {AREAS, IArea} from "/@lib@/commons/areas.js";
import {InfoResetSearchCrits, InfoSearchCritsChange, InfoSearchResults} from "/@lib@/store/search.js";
import {FORMS} from "/@lib@/commons/forms.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";


/**
 * Widget SearchCrit : affichage de critères de recherches.
 */
export interface SearchCrit extends BaseElementAsync {
	initialize(init: OSearchCritInit): this
}

export interface OSearchCritInit extends OSkinableInit, OLastDatasInit {
	reg?: IReg<IDepotUiEnv>

	/** Construction d'un layout custom des critères à injecter. */
	buildCritLayout?: (searchCrit: SearchCrit, holder: Node) => Promise<void>

	/** Liste du registre des critères à construire (IArea<SearchCrit>). */
	critsList?: string
	/** Liste des critères à construire. */
	crits?: IArea<SearchCrit>[]

	/**
	 * InfoBroker pour :
	 * - InfoResetSearchCrits : reconstruire les critères avec une nouvelle source de props json,
	 * - dispatcher un event à chaque changement des critères de recherche,
	 * - afficher les résultats de la dernière recherche dans les critères (agrégations).
	 */
	infoBroker?: IInfoBroker
}

export class SearchCrit extends BaseElementAsync implements IInfoConsumer {
	reg: IReg<IDepotUiEnv>;

	crits?: IArea<SearchCrit>[]

	infoBroker: IInfoBroker;

	protected async _initialize(init: OSearchCritInit) {
		this.reg = init.reg;
		this.infoBroker = init.infoBroker;
		this.infoBroker.addConsumer(this);
		if (init.critsList) this.crits = init.reg.getList(init.critsList);
		else this.crits = init.crits;
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this.reg.installSkin("form-control-areas", sr);
		this._initAndInstallSkin(this.localName, init);
		if (init.buildCritLayout) {
			await init.buildCritLayout(this, sr);
		} else {
			sr.append(<div area-ids="*"/>);
		}
		sr.addEventListener("change", (ev: Event) => {
			this.infoBroker.dispatchInfo(new InfoSearchCritsChange(FORMS.formToJson(sr, {})), this)
		})
	}

	onInfo(info: IInfo) {
		if (info instanceof InfoResetSearchCrits) {
			AREAS.applyLayout(this.shadowRoot, this.crits, this, true).then(() => {
				FORMS.jsonToForm(info.props, this.shadowRoot);
			})
		} else if (info instanceof InfoSearchResults) {
			//todo refreshwidgets agregations
		}
	}
}


REG.reg.registerSkin('store-search-crit', 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
	}

	[hidden] {
		display: none;
	}
`);

customElements.define('store-search-crit', SearchCrit);
